/* deals: перевод строк окна «Сделки» (deals.tsx, deals-api.ts) и блока «Сделки» в карточке контакта. Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "Сделки": "Deals",
  "Воронка и канбан": "Pipeline and kanban",
  "Сделок пока нет.": "No deals yet.",
  "в работе": "open",
  "выиграна": "won",
  "проиграна": "lost",
  "Воронка": "Pipeline",
  "Выиграны": "Won",
  "Проиграны": "Lost",
  "Сделка, клиент, компания, продавец": "Deal, client, company, salesperson",
  "Поиск сделок": "Search deals",
  "{n} в работе на {sum}": "{n} open worth {sum}",
  "карточка показывает дни на этапе; сумма — у сделок с указанной суммой": "a card shows days in stage; the sum counts deals with an amount",
  "без суммы": "no amount",
  "ещё {n} — уточните поиск": "{n} more — narrow the search",
  "пусто": "empty",
  "В воронке нет этапов «в работе» — добавьте их в «Этапы».": "This pipeline has no open stages — add them in “Stages”.",
  "{n} сделок": "{n} deals",
  "Сумма": "Amount",
  "Закрыта": "Closed",
  "Сделка с {name}": "Deal with {name}",
  "Сделка создана": "Deal created",
  "К сделкам": "Back to deals",
  "Новая сделка": "New deal",
  "Валюта": "Currency",
  "Создать сделку": "Create deal",
  "сменить": "change",
  "Имя, телефон или почта контакта": "Contact name, phone or email",
  "Ожидаемое закрытие": "Expected close",
  "Следующий шаг": "Next step",
  "Сделка сохранена": "Deal saved",
  "Удалить сделку «{title}»? История этапов тоже удалится.": "Delete deal “{title}”? Its stage history is deleted too.",
  "Сделка удалена": "Deal deleted",
  "{n} на этапе": "{n} in stage",
  "открыть в Zoho CRM": "open in Zoho CRM",
  "Этап изменён": "Stage changed",
  "Этап сделки": "Deal stage",
  "Данные сделки": "Deal details",
  "не назначен · продавец Zoho: {name}": "unassigned · Zoho salesperson: {name}",
  "Причина проигрыша": "Reason for loss",
  "Реклама": "Ads",
  "Клиент и история": "Client and history",
  "Контакт не указан": "No contact",
  "выбрать": "pick",
  "Контакт сделки изменён": "Deal contact changed",
  "Компания не указана": "No company",
  "Компания сделки изменена": "Deal company changed",
  "История этапов": "Stage history",
  "Пока нет записей.": "No records yet.",
  "Создана {when}": "Created {when}",
  "закрыта {when}": "closed {when}",
  "Порядок этапов сохранён": "Stage order saved",
  "Этапы воронки «{name}»": "Stages of pipeline “{name}”",
  "Названия и порядок — как на канбане. «Выиграна» и «проиграна» закрывают сделку. Этапы из Zoho CRM остаются связанными с CRM по исходному названию, переименование это не ломает.":
    "Names and order are what the kanban shows. “Won” and “lost” close the deal. Stages from Zoho CRM stay linked to CRM by their original name; renaming does not break that.",
  "Название воронки": "Pipeline name",
  "Воронка переименована": "Pipeline renamed",
  "Переименовать": "Rename",
  "Теперь это воронка по умолчанию": "This is now the default pipeline",
  "Сделать основной": "Make default",
  "воронка по умолчанию": "default pipeline",
  "Воронка удалена": "Pipeline deleted",
  "Удалить воронку": "Delete pipeline",
  "Этап переименован": "Stage renamed",
  "Название этапа": "Stage name",
  "Тип этапа изменён": "Stage type changed",
  "Тип этапа": "Stage type",
  "Цвет этапа изменён": "Stage colour changed",
  "Цвет этапа": "Stage colour",
  "{n} сд.": "{n} deals",
  "Выше": "Up",
  "Ниже": "Down",
  "На этапе есть сделки — сначала перенесите их": "There are deals in this stage — move them first",
  "Этап удалён": "Stage deleted",
  "Этап добавлен": "Stage added",
  "Новый этап": "New stage",
  "Название нового этапа": "New stage name",
  "Тип нового этапа": "New stage type",
  "Воронка создана — выберите её в списке над канбаном": "Pipeline created — pick it in the list above the kanban",
  "Новая воронка": "New pipeline",
  "Название новой воронки": "New pipeline name",
  "Создать воронку": "Create pipeline",
  "Сделки — воронка и канбан": "Deals — pipeline and kanban",
  "Сделки из Zoho CRM и новые из переписки: этапы воронки колонками, сумма и дни на этапе, карточка с клиентом, компанией и историей этапов. Правка в Hub главнее CRM.":
    "Deals from Zoho CRM and new ones from conversations: pipeline stages as columns, amount and days in stage, a card with the client, company and stage history. Edits in Hub win over CRM.",
  "Заказы и счета Books": "Books orders and invoices",
  "Счетов на {sum}": "Invoiced {sum}",
  "к оплате {sum}": "{sum} due",
  "оплачено полностью": "fully paid",
  "Счёт {n}": "Invoice {n}",
  "Заказ {n}": "Order {n}",
  "долг {sum}": "{sum} outstanding",
  "В Books нет заказов по этой сделке.": "No Books orders for this deal.",
  "черновик": "draft",
  "открыт": "open",
  "выставлен счёт": "invoiced",
  "частично выставлен": "partially invoiced",
  "просрочен": "overdue",
  "аннулирован": "void",
  "отправлен": "sent",
  "оплачен": "paid",
  "частично оплачен": "partially paid",
  "не оплачен": "unpaid",
  "закрыт": "closed",
};
export default d;
